/** True on macOS/iOS, where the modifier key for shortcuts is Cmd rather than Ctrl. */
export function isMac(): boolean {
  if (typeof navigator === 'undefined') return false;
  const uaData = (navigator as typeof navigator & { userAgentData?: { platform?: string } })
    .userAgentData;
  const platform = uaData?.platform ?? navigator.platform ?? navigator.userAgent ?? '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}

/** "⌘" on macOS, "Ctrl" everywhere else — for building shortcut hint labels. */
export function modKeyLabel(): string {
  return isMac() ? '⌘' : 'Ctrl';
}

/** e.g. modShortcutLabel('K') -> "⌘K" on macOS, "Ctrl+K" elsewhere. */
export function modShortcutLabel(key: string): string {
  return isMac() ? `⌘${key}` : `Ctrl+${key}`;
}
